export default __webpack_public_path__ + "static/media/upload.e52cdf7e.svg";